/* eslint-disable no-shadow */

import ApiService from '@/services/api.service';
import { apiEndpoint } from '@/shared';

const endpoint = `${apiEndpoint}/price-comparison-widget`;

const state = {
  widgetId: null,
  channelId: null,
  heading: null,
  additionalText: null,
  channels: null,
  isEnabled: null,
  willEnabled: null,
};

const getters = {
  widgetId: (state) => (state.widgetId != null ? state.widgetId : null),
  channelId: (state) => (state.channelId != null ? state.channelId : null),
  heading: (state) => (state.heading != null ? state.heading : ''),
  additionalText: (state) => (state.additionalText != null ? state.additionalText : ''),
  channels: (state) => (state.channels != null ? state.channels : {}),
  isEnabled: (state) => (state.isEnabled != null ? state.isEnabled : false),
  willEnabled: (state) => (state.willEnabled != null ? state.willEnabled : false),
};

const mutations = {
  clearErrors() {
    // do nothing
  },
  setWidgetId(state, widgetId) {
    state.widgetId = widgetId;
  },
  setIsEnabled(state, isEnabled) {
    state.isEnabled = isEnabled;
  },
  setWillEnabled(state, willEnabled) {
    state.willEnabled = willEnabled;
  },
  setHeading(state, heading) {
    state.heading = heading;
  },
  setAdditionalText(state, additionalText) {
    state.additionalText = additionalText;
  },
  setChannels(state, array) {
    state.channels = {};
    // eslint-disable-next-line array-callback-return
    array.map((ch, key) => {
      // eslint-disable-next-line no-restricted-globals
      if (!isNaN(ch)) {
        state.channels[`additionalProp${key + 1}`] = ch.toString();
      }
    });
  },
  setChannelId(state, channelId) {
    state.channelId = channelId;
  },
  setData(state, data) {
    state.widgetId = data.id ?? null;
    state.channelId = data.propertyId ?? null;
    state.heading = data.heading ?? null;
    state.additionalText = data.additionalText ?? null;
    state.channels = data.channels ?? null;
    state.isEnabled = data.isEnabled ?? null;
  },
};

const actions = {
  async getWidgetSettings({ commit }, channelId) {
    try {
      const response = await ApiService.get(`${endpoint}/${channelId}`);
      const data = response.data ? response.data : null;
      commit('setData', data);
      commit('setWillEnabled', data.isEnabled);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.message);
    }
  },
  async setWidgetSettings({ getters }, channelId) {
    try {
      // if (getters.widgetId === null) { throw new Error('No widget received'); }
      const data = {
        isEnabled: getters.willEnabled,
        heading: getters.heading,
        additionalText: getters.additionalText,
        channels: getters.channels,
      };
      await ApiService.post(`${endpoint}/${channelId}`, data);
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error.message);
    }
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
